<template>
  <v-container fluid class="pa-2">
    <div v-if="loading" id="loading">
      <v-progress-circular
        v-if="loading"
        :size="40"
        :width="5"
        color="purple"
        indeterminates
      >
      </v-progress-circular>
    </div>

    <v-row no-gutters>
      <v-col class="d-flex" cols="6" sm="4" xs="4">
        <label for="inventorydate" class="header-label">棚卸日：</label>
        <DatePicker
          :disabled-dates="disabledDates"
          v-model="inventorydate"
          locale="jp-ja"
          format="yyyy/MM/dd"
          class="datepick"
          @input="setSelectedDate"
          dense
        ></DatePicker>
      </v-col>
      <v-col class="d-flex" cols="6" sm="4" xs="4">
        <label for="inventoryModes" class="header-label">モード：</label>
        <v-select
          :options="inventoryModes"
          v-model="selectedMode"
          class="selectBoxMode"
          @input="setSelectedMode"
          dense
          :clearable="false"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4" xs="4">
        <label for="inventoryPlaces" class="header-label">場所：</label>
        <v-select
          :options="inventoryPlaces"
          v-model="selectedPlace"
          class="selectBoxInventoryPlace"
          @input="setSelectedPlace"
          dense
          :clearable="false"
        ></v-select>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col class="d-flex" cols="4" sm="4" xs="4" no-gutters>
        <div v-if="limit">
          <v-btn v-on:click="dialog_register = true" small color="error"
            >棚卸データ登録</v-btn
          >
        </div>
      </v-col>
      <v-col class="d-flex text-left" cols="8" sm="8" xs="8" no-gutters>
        {{ invention_status }}<br />{{ limit_time }}
      </v-col>
    </v-row>

    <vue-good-table
      :columns="columns"
      :rows="rows"
      :max-height="table_size"
      :group-options="{
        enabled: true,
      }"
      :sort-options="{
        enabled: false,
      }"
    >
      <div slot="emptystate" class="text-center">
        <br />
        対象データがありません。<br />
        棚卸日、モード、場所を選択して下さい
      </div>
      <template slot="table-header-row" slot-scope="props">
        <span class="table-header" style="color: blue">
          {{ props.row.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field == 'inventoryNum1'">
          <v-text-field
            single-line
            readonly
            background-color="#FFFDE7"
            height="14px"
            dense
            maxlength="6"
            :suffix="props.row.inventoryScale1"
            type="numeric"
            step="0.01"
            class="no-spin tab_move shrink table-record"
            v-model="props.row.inventoryNum1"
            @focus="
              show_process($event, props.row.originalIndex, props.row.inventoryNum1, '1')
            "
            @blur="
              blur_process($event, props.row.originalIndex, props.row.inventoryNum1, '1')
            "
            data-layout="numeric"
            :rules="[number]"
          />
        </div>
        <div v-if="props.column.field == 'inventoryNum2'">
          <v-text-field
            single-line
            readonly
            background-color="#FFFDE7"
            height="14px"
            dense
            maxlength="6"
            :suffix="props.row.inventoryScale2"
            type="numeric"
            step="0.01"
            class="no-spin tab_move shrink table-record"
            v-model="props.row.inventoryNum2"
            @focus="
              show_process($event, props.row.originalIndex, props.row.inventoryNum2, '2')
            "
            @blur="
              blur_process($event, props.row.originalIndex, props.row.inventoryNum2, '2')
            "
            data-layout="numeric"
            :rules="[number]"
          />
        </div>
      </template>
    </vue-good-table>
    <vue-touch-keyboard
      :options="options"
      v-if="visible"
      :layout="layout"
      :next="moveNext"
      :back="movePrev"
      :change="changeValue"
      :input="input"
      :clear="clear"
      :next_place="next_place"
      :back_place="back_place"
    />

    <v-dialog v-model="dialog_register" max-width="290">
      <v-card>
        <v-card-title class="headline">登録確認</v-card-title>
        <v-card-text>
          {{ $store.state.tenpoName }}の<br />
          棚卸データを登録しますか？
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_register = false">
            戻る
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialog_register = false"
            v-on:click="registerInventoryData"
          >
            登録する
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="register_snackbar" :timeout="timeout">
      {{ register_result_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="register_snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog_confirm_date" max-width="290">
      <v-card>
        <v-card-title class="headline">棚卸日 切り替え前確認</v-card-title>
        <v-card-text>
          棚卸日を切り替える場合は、<br />
          入力中の棚卸データは削除されます。<br />
          一度、登録後に切替をオススメします。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog_confirm_date = false"
            v-on:click="setBeforeDate"
          >
            戻る
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialog_confirm_date = false"
            v-on:click="changedCondition"
          >
            切り替える
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirm_mode" max-width="290">
      <v-card>
        <v-card-title class="headline">モード 切り替え前確認</v-card-title>
        <v-card-text>
          モードを切り替える場合は、<br />
          入力中の棚卸データは削除されます。<br />
          一度、登録後に切替をオススメします。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog_confirm_mode = false"
            v-on:click="setBeforeMode"
          >
            戻る
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialog_confirm_mode = false"
            v-on:click="changedCondition"
          >
            切り替える
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirm_reload" max-width="290">
      <v-card>
        <v-card-title class="headline">遷移前確認</v-card-title>
        <v-card-text>
          画面遷移する場合は、<br />
          入力中の棚卸データは<br />
          削除される可能性があります。<br />
          一度、登録後に切替をオススメします。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog_confirm_reload = false"
            v-on:click="backToWindow"
          >
            戻る
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="dialog_confirm_reload = false"
            v-on:click="goToWindow"
          >
            切り替える
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="api_error" max-width="320">
      <v-card>
        <v-card-title class="headline">{{ card_title }}</v-card-title>
        <v-card-text>
          {{ card_content }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="api_error = false"> 閉じる </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import VModal from "vue-js-modal";
import DatePicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

// 日付選択用の初期の日付取得
// 店舗の営業時間を取得するのは面倒なので、ひとまずはAM5時で日付切り替え(-5時間する)
var five_hour_ago = new Date();
five_hour_ago.setHours(five_hour_ago.getHours() - 5);
var twoDaysAgo = new Date();
twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);

export default {
  name: "InputInventory",
  components: {
    VModal,
    DatePicker,
    vSelect,
  },
  beforeRouteLeave(to, from, next) {
    next();
    // 要望があれば復活させる
    /*
    // 別画面へ遷移する場合
    if (this.change_data_flg) {
      this.next_func = next;
      this.dialog_confirm_reload = true;
    } else{
      // 何も入力していない場合は、画面遷移する
      next();
    }
    */
  },
  data() {
    return {
      loading: false,
      dialog_confirm_date: false,
      dialog_confirm_mode: false,
      dialog_confirm_reload: false,
      dialog_register: false,
      change_data_flg: false,
      next_func: null,
      stored_column: "",
      register_snackbar: false,
      limit: true,
      timeout: 2000,
      register_result_message: "",
      card_title: "",
      card_content: "",
      system_error_title: "システムエラー",
      system_error_content:
        "インターネット接続を確認してください。解決しない場合は、再ログイン後に再実施をお願いします。 ",
      visible: false,
      layout: "normal",
      input: null,
      table_size: "250px",
      api_result: null,
      api_error: false,
      height: window.innerHeight,
      inventorydate: null,
      before_inventorydate: null,
      limit_time: "",
      invention_status: "",
      disabledDates: {
        to: twoDaysAgo,
        from: five_hour_ago,
      },
      selectedMode: { label: "日次", code: "0" },
      before_selectedMode: null,
      inventoryModes: [
        { label: "日次", code: "0" },
        { label: "全商品", code: "1" },
      ],
      selectedPlace: { label: "", code: "" },
      inventoryPlaces: [],
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      columns: [
        {
          label: "仕入品コード",
          field: "shiirehincd",
          type: "string",
          html: true,
          hidden: true,
        },
        {
          label: "仕入先仕入品コード",
          field: "shiiresakihincd",
          type: "string",
          html: true,
          hidden: true,
        },
        {
          label: "棚単位１",
          field: "inventoryNum1",
          type: "decimal",
          html: true,
        },
        {
          label: "",
          field: "inventoryScale1",
          type: "string",
          html: true,
          hidden: true,
        },
        {
          label: "棚単位２",
          field: "inventoryNum2",
          type: "decimal",
          html: true,
        },
        {
          label: "",
          field: "inventoryScale2",
          type: "string",
          html: true,
          hidden: true,
        },
        {
          label: "",
          field: "tana_order",
          type: "decimal",
          html: true,
          hidden: true,
        },
      ],
      rows: [],
      name: "",
      apiResult: "",
      timer: "",
      required: (value) => !!value || "必ず入力してください",
      number: (value) =>
        !value ||
        !isNaN(Number.parseFloat(value)) ||
        value == "." ||
        "数字を入力してください",
    };
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
    // 画面サイズに合わせたテーブルサイズ設定
    this.autoHeight();
    // 画面は縦で利用する前提とする
    // window.addEventListener('resize', this.autoHeight);
    // 棚卸対象日を設定
    this.setTargetDate();
    // 棚卸スケジュールのチェックしてモードを設定
    this.getInventorySchedule();
    // 棚卸状況取得
    this.getInventoryStituation();
    // 棚卸状況は1分に1回取得する
    this.timer = setTimeout(this.getInventoryStituation, 60000);
    // 画面リロードのイベントをフック
    window.addEventListener("beforeunload", this.reloadWindow);
  },
  beforeDestroy() {
    // timerを止める
    clearInterval(this.timer);
    // window.removeEventListener('resize', this.autoHeight);
    window.removeEventListener("beforeunload", this.reloadWindow);
  },
  filters: {},
  watch: {
    inventorydate: function (newVal, oldVal) {
      // 棚卸日が変更された時に変数に保持しておく（確認ダイアログで戻せるように）
      this.before_inventorydate = oldVal;
    },
    selectedMode: function (newVal, oldVal) {
      // モードが変更された時に変数に保持しておく（確認ダイアログで戻せるように）
      this.before_selectedMode = oldVal;
    },
  },
  methods: {
    setTargetDate: function () {
      this.inventorydate = five_hour_ago;
    },
    customDateFormat: function (value) {
      return moment(value).format("YYYY/MM/DD");
    },
    autoHeight: function () {
      this.height = window.innerHeight;
      // 画面サイズに合わせた高さを返却します。
      switch (true) {
        case this.height <= 500:
          this.table_size = "100px";
          break;
        case this.height <= 600:
          this.table_size = "300px";
          break;
        case this.height <= 700:
          this.table_size = "300px";
          break;
        case this.height <= 800:
          this.table_size = "380px";
          break;
        case this.height <= 900:
          this.table_size = "480px";
          break;
        case this.height <= 1100:
          this.table_size = "600px";
          break;
        case this.height >= 1100:
          this.table_size = "800px";
          break;
      }
    },
    reloadWindow: function (event) {
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    backToWindow: function () {
      // 画面遷移しない
      this.next_func(false);
    },
    goToWindow: function () {
      // 画面遷移する
      this.next_func();
    },
    moveNext: function (text) {
      let inputs = document.querySelectorAll(".tab_move");
      let item_input;
      let found = false;
      [].forEach.call(inputs, (item, i) => {
        item_input = item.querySelector("input");
        if (!found && item_input == this.input && i < inputs.length - 1) {
          found = true;
          this.$nextTick(() => {
            inputs[i + 1].querySelector("input").focus();
          });
        }
      });
      if (!found) {
        // 次の場所へ切り替えに変更
        this.next_place();
        this.$nextTick(() => {
          // DOMが更新後に再取得してフォーカスを当てる
          inputs[0].querySelector("input").focus();
        });
      }
    },
    movePrev: function (text) {
      let inputs = document.querySelectorAll(".tab_move");
      let item_input;
      let found = false;
      [].forEach.call(inputs, (item, i) => {
        item_input = item.querySelector("input");
        if (!found && item_input == this.input && i < inputs.length) {
          if (i > 0) {
            found = true;
            this.$nextTick(() => {
              inputs[i - 1].querySelector("input").focus();
            });
          }
        }
      });
      if (!found) {
        // 次の場所へ切り替えに変更
        this.back_place();
        this.$nextTick(() => {
          // DOMが更新後に再取得してフォーカスを当てる
          inputs = document.querySelectorAll(".tab_move");
          inputs[inputs.length - 1].querySelector("input").focus();
        });
      }
    },
    changeValue: function (text) {
      // ソフトウェアキーボードで値変更時
      this.change_data_flg = true;
    },
    clear: function (e, text) {
      // 値を削除して、inputイベントを起す
      this.input.value = "";
      var evt = new Event("input");
      this.input.dispatchEvent(evt);
      // フォーカスイベント
      evt = new FocusEvent("blur");
      this.input.dispatchEvent(evt);
    },
    change_place: function (mode) {
      var currentIndex = this.inventoryPlaces.findIndex((object) => {
        return object.code === this.selectedPlace.code;
      });
      var maxIndex = this.inventoryPlaces.length - 1;
      var changedIndex = currentIndex;

      // モードに応じて変更後のインデックスを設定
      if (mode == "next") {
        // 次の棚卸場所
        if (currentIndex < maxIndex) {
          changedIndex = changedIndex + 1;
        } else {
          changedIndex = 0;
        }
      } else {
        // 前の棚卸場所
        if (currentIndex - 1 >= 0) {
          changedIndex = changedIndex - 1;
        } else {
          changedIndex = maxIndex;
        }
      }
      //変更後の棚卸明場所を設定して、対象商品を取得
      this.selectedPlace = this.inventoryPlaces[changedIndex];
      this.setSelectedPlace();
    },
    next_place: function () {
      // 次の棚卸場所へ切り替え
      this.change_place("next");
    },
    back_place: function () {
      // 前の棚卸場所へ切り替え
      this.change_place("back");
    },
    blur_process: function (e, index, value, pattern) {
      //console.log("blur:"+this.stored_column);
      e.target.style.background = "#FFFDE7";
      var regex = new RegExp(/^\.[0-9]+$/);
      var regex_continuous = new RegExp(/^\.{2,}[0-9]*|[0-9]+\.{2,}[0-9]*/);
      //ドットを重複して連続した場合は、まとめてあげる
      if (value && regex_continuous.test(value)) {
        value = value.toString().replace(/\.{2,}/, ".");
      }
      //ドット始まり、複数のドットがある場合
      if (
        value &&
        (regex.test(value) || (value.toString().match(/\./g) || []).length >= 2)
      ) {
        // 変換して数字を整える (.2 -> 0.2など)
        value = Number.parseFloat(value);
      }
      // 配列はリアクティブに反映されないので、$setを利用する
      var temp_data = this.rows[index];
      if (pattern == "1") {
        temp_data.children[0].inventoryNum1 = value;
      } else {
        temp_data.children[0].inventoryNum2 = value;
      }
      this.$set(this.rows, index, temp_data);
      // フォーカスを外れた時に、LocalStorageで保管する
      this.storeLocalStrage();
    },
    show_process: function (e, index, value, pattern) {
      e.target.style.background = "#ffdab9";
      this.input = e.target;
      this.layout = e.target.dataset.layout;

      // ソフトウェアキーボードを表示する
      if (!this.visible) this.visible = true;
      // 現状入力中の項目でない場合は、一度クリアを行うため、フォーカスカラムを保存
      var input_column = this.selectedPlace.code + document.activeElement.id;
      if (input_column != this.stored_column) {
        this.stored_column = input_column;
        // 値が上書きされるように、選択状態にしておく
        document.activeElement.select();
      }
    },
    hide: function () {
      this.visible = false;
    },
    setSelectedDate: function () {
      // 現在のデータを破棄して進むか？をユーザーへ確認（更新後に切り替えを促す）
      this.dialog_confirm_date = true;
    },
    setBeforeDate: function () {
      // 変更前の値から戻す
      this.inventorydate = this.before_inventorydate;
      this.before_inventorydate = null;
    },
    setBeforeMode: function () {
      // 変更前の値から戻す
      this.selectedMode = this.before_selectedMode;
      this.before_selectedMode = null;
    },
    setSelectedMode: function () {
      // 現在のデータを破棄して進むか？をユーザーへ確認（更新後に切り替えを促す）
      this.dialog_confirm_mode = true;
    },
    setSelectedPlace: function () {
      if (this.checkLocalStorageDate()) {
        // LocalStrageのデータを表示させる
        this.setInventoryData_fromLocalStorage();
      } else {
        // 初回にAPIで全件取得しているため追加取得しない。wifi切れにも対応
        this.rows = [];
        console.log("追加取得なし");
        //this.getInventoryData();
      }
    },
    changedCondition: function () {
      // LocalStrageを破棄
      this.deleteLocalStrage();
      // 棚卸場所＆データを再取得
      this.getInventoryPlace();
      // 棚卸状況を再取得
      this.getInventoryStituation();
    },
    checkLocalStorageDate: function () {
      let store_data = this.$store.state.inventoryData;
      let current_mode = this.$store.state.inventoryMode;
      let target_date = this.customDateFormat(this.inventorydate);
      // 棚卸日、モード、場所でLocalStorageにあるか？をチェック
      if (
        store_data[target_date] &&
        current_mode == this.selectedMode.code &&
        this.selectedPlace.code in store_data[target_date]
      ) {
        console.log("LocalStorageあり");
        return true;
      } else {
        console.log("LocalStorageなし");
        return false;
      }
    },
    hide_confirm: function () {
      this.$modal.hide("get-confirm");
    },
    getInventoryPlace: function () {
      (this.loading = true),
        (this.api_result = null),
        axios
          .get("/api/get_inventory_place.php", {
            params: {
              api_token: this.$store.state.api_token,
              tenpocd: this.$store.state.tenpoCd,
              mode: this.selectedMode.code,
            },
          })
          .then(
            (response) => (
              (this.api_result = response.data),
              this.setInventoryPlaceSelector(),
              // 起動時に全棚の商品データを取得する
              this.getAllInventoryData(),
              (this.loading = false)
            )
          )
          .catch(
            (error) => (
              (this.loading = false),
              (this.card_title = this.system_error_title),
              (this.card_content = this.system_error_content),
              (this.api_error = true)
            )
          );
    },
    setInventoryPlaceSelector: function () {
      this.inventoryPlaces = [];
      this.api_result.forEach((element) => {
        this.inventoryPlaces.push({ label: element.placename, code: element.placecd });
      });
    },
    getAllInventoryData: function () {
      this.loading = true;
      this.api_result = null;
      // 初期として、一番初めの棚を設計しておく
      this.selectedPlace = this.inventoryPlaces[0];
      if (!this.checkLocalStorageDate()) {
        // LocalStorageに該当日のデータがない場合は全取得
        axios
          .get("/api/get_inventory_data_all.php", {
            params: {
              api_token: this.$store.state.api_token,
              tenpocd: this.$store.state.tenpoCd,
              date: this.customDateFormat(this.inventorydate),
              mode: this.selectedMode.code,
            },
          })
          .then(
            (response) => (
              (this.api_result = response.data),
              this.setInventoryDataAll(),
              (this.loading = false)
            )
          )
          .catch(
            (error) => (
              console.log(error),
              (this.loading = false),
              (this.card_title = this.system_error_title),
              (this.card_content = this.system_error_content),
              (this.api_error = true)
            )
          );
      } else {
        //LocalStrageから表示
        this.setInventoryData_fromLocalStorage();
      }
    },
    setInventoryDataAll: function () {
      console.log("APIから表示：setInventoryDataAll");
      let rows = [];
      let tmp_num1 = null;
      let tmp_num2 = null;
      let base = 100;
      let tmp_place = null;
      this.api_result.forEach((element) => {
        if (tmp_place && tmp_place != element.tanabasyo) {
          //取得データをlocalStrageへ保管
          this.storeLocalStrage(
            this.inventorydate,
            tmp_place,
            rows,
            this.selectedMode.code
          );
          rows = [];
        }
        //小数第3位は切り上げる
        tmp_num1 = null;
        tmp_num2 = null;
        if (element.basic_num) tmp_num1 = Math.ceil(element.basic_num * base) / base;
        if (element.sub_num1) tmp_num2 = Math.ceil(element.sub_num1 * base) / base;
        rows.push({
          mode: "span",
          label: element.shiirehinfullnm,
          children: [
            {
              shiirehincd: element.shiirehincd,
              shiiresakihincd: element.shiiresakihincd,
              inventoryNum1: tmp_num1,
              inventoryScale1: element.taninm,
              inventoryNum2: tmp_num2,
              inventoryScale2: element.tanisub1nm,
              tana_order: element.tana_order,
            },
          ],
        });
        tmp_place = element.tanabasyo;
      });
      if (tmp_place) {
        //取得データをlocalStrageへ保管
        this.storeLocalStrage(
          this.inventorydate,
          tmp_place,
          rows,
          this.selectedMode.code
        );
      }
      //初期として、一番初めの棚を表示しておく
      this.selectedPlace = this.inventoryPlaces[0];
      this.setSelectedPlace();
    },
    getInventoryData: function () {
      this.rows = [];
      if (this.inventorydate && this.selectedPlace && this.selectedMode) {
        (this.loading = true),
          (this.api_result = null),
          axios
            .get("/api/get_inventory_data.php", {
              params: {
                api_token: this.$store.state.api_token,
                tenpocd: this.$store.state.tenpoCd,
                date: this.customDateFormat(this.inventorydate),
                place: this.selectedPlace.code,
                mode: this.selectedMode.code,
              },
            })
            .then(
              (response) => (
                (this.api_result = response.data),
                this.setInventoryData(),
                (this.loading = false)
              )
            )
            .catch(
              (error) => (
                (this.loading = false),
                (this.card_title = this.system_error_title),
                (this.card_content = this.system_error_content),
                (this.api_error = true)
              )
            );
      }
    },
    setInventoryData: function () {
      console.log("APIから表示：setInventoryData");
      this.rows = [];
      let tmp_num1 = null;
      let tmp_num2 = null;
      let base = 100;
      this.api_result.forEach((element) => {
        //小数第3位は切り上げる
        tmp_num1 = null;
        tmp_num2 = null;
        if (element.basic_num) tmp_num1 = Math.ceil(element.basic_num * base) / base;
        if (element.sub_num1) tmp_num2 = Math.ceil(element.sub_num1 * base) / base;
        this.rows.push({
          mode: "span",
          label: element.shiirehinfullnm,
          children: [
            {
              shiirehincd: element.shiirehincd,
              shiiresakihincd: element.shiiresakihincd,
              inventoryNum1: tmp_num1,
              inventoryScale1: element.taninm,
              inventoryNum2: tmp_num2,
              inventoryScale2: element.tanisub1nm,
              tana_order: element.tana_order,
            },
          ],
        });
      });
      //取得データをlocalStrageへ保管
      this.storeLocalStrage();
    },
    setInventoryData_fromLocalStorage: function () {
      //console.log("LocalStrageから表示");
      this.rows = this.$store.state.inventoryData[
        this.customDateFormat(this.inventorydate)
      ][this.selectedPlace.code];
    },
    storeLocalStrage: function (param_date, param_place, param_data, param_mode_code) {
      // 現在のLocalStrageのデータを保管
      let store_data = this.$store.state.inventoryData;
      // 引数が指定されて入れば利用する
      let date = null;
      let place = null;
      let row_data = null;
      let mode = null;
      if (param_date) date = param_date;
      else date = this.inventorydate;
      if (param_place) place = param_place;
      else place = this.selectedPlace.code;
      if (param_data) row_data = param_data;
      else row_data = this.rows;
      if (param_mode_code) mode = param_mode_code;
      else mode = this.selectedMode.code;

      // 日付＆場所毎に棚情報を保存する
      if (store_data[this.customDateFormat(date)] == null) {
        store_data[this.customDateFormat(date)] = {};
      }
      store_data[this.customDateFormat(date)][place] = row_data;

      this.$store.dispatch("storeData", {
        date: this.customDateFormat(date),
        mode: mode,
        inputData: store_data,
      });
    },
    deleteLocalStrage: function () {
      this.$store.dispatch("storeData", {
        date: null,
        mode: null,
        inputData: {},
      });
    },
    getInventorySchedule: function () {
      (this.api_result = null),
        axios
          .get("/api/get_inventory_schedule.php", {
            params: {
              api_token: this.$store.state.api_token,
              date: this.customDateFormat(this.inventorydate),
            },
          })
          .then(
            (response) => (
              (this.api_result = response.data), this.setInventorySchedulen()
            )
          )
          .catch((error) =>
            //何もしない
            console.log(error)
          );
    },
    setInventorySchedulen: function () {
      // 全棚であれば、初期モードを変更する
      if (this.api_result) {
        this.selectedMode = this.inventoryModes[1];
      }
      // 棚卸場所取得
      this.getInventoryPlace();
    },
    getInventoryStituation: function () {
      (this.api_result = null),
        axios
          .get("/api/get_inventory_situation.php", {
            params: {
              api_token: this.$store.state.api_token,
              tenpocd: this.$store.state.tenpoCd,
              date: this.customDateFormat(this.inventorydate),
              mode: this.selectedMode.code,
            },
          })
          .then(
            (response) => (
              (this.api_result = response.data), this.setInventoryStituation()
            )
          )
          .catch((error) =>
            //何もしない
            console.log(error)
          );
    },
    setInventoryStituation: function () {
      this.invention_status = this.api_result[0];
      if (this.api_result[1] != "out") {
        this.limit_time = this.api_result[1];
        this.limit = true;
      } else {
        this.limit_time = "更新期限切れ";
        this.limit = false;
      }
    },
    registerInventoryData: function () {
      // 対象日のデータのみを取得
      let targetDate_data = this.$store.state.inventoryData[
        this.customDateFormat(this.inventorydate)
      ];
      // 形式は、{場所コード： {仕入れ品コード：{inventoryNum1: xx, inventoryNum2: xx}}}
      let register_data = {};

      // 登録用に整形（APIデータが多くならないようにする）
      for (var placecd in targetDate_data) {
        //場所コードでループ
        register_data[placecd] = {};
        for (var i in targetDate_data[placecd]) {
          //場所コード内の商品明細でループ
          register_data[placecd][i] = {
            inventoryNum1:
              parseFloat(targetDate_data[placecd][i]["children"][0]["inventoryNum1"]) ||
              0,
            inventoryNum2:
              parseFloat(targetDate_data[placecd][i]["children"][0]["inventoryNum2"]) ||
              0,
            shiirehincd: targetDate_data[placecd][i]["children"][0]["shiirehincd"],
            shiiresakihincd:
              targetDate_data[placecd][i]["children"][0]["shiiresakihincd"],
            tana_order: targetDate_data[placecd][i]["children"][0]["tana_order"],
          };
        }
      }
      // 登録
      if (register_data) {
        (this.loading = true),
          (this.api_result = null),
          axios
            .post("/api/register_inventory_data.php", {
              api_token: this.$store.state.api_token,
              kaisyacd: this.$store.state.kaisyacd,
              shaincd: this.$store.state.shaincd,
              tenpocd: this.$store.state.tenpoCd,
              mode: this.selectedMode.code,
              date: this.customDateFormat(this.inventorydate),
              inventory_data: register_data,
            })
            .then(
              (response) => (
                (this.api_result = response.data),
                this.result_register(),
                this.getInventoryStituation(),
                (this.change_data_flg = false),
                (this.loading = false)
              )
            )
            .catch(
              (error) => (
                (this.loading = false),
                (this.card_title = this.system_error_title),
                (this.card_content = this.system_error_content),
                (this.api_error = true)
              )
            );
      }
    },
    result_register: function () {
      if (this.api_result == "10" || this.api_result == "11" || this.api_result == "12") {
        this.card_title = "入力エラー";
        this.card_content = "店舗、棚卸日、モードの選択のいずれかに誤りがあります。";
        this.api_error = true;
      } else if (this.api_result == "20") {
        this.card_title = "棚卸リミット時間";
        this.card_content =
          "過去日の棚卸は登録できません。（18時を過ぎると前日分は登録出来ません。）";
        this.api_error = true;
      } else if (this.api_result == "30") {
        this.card_title = "承認ステータス";
        this.card_content = "上長が承認済のため修正できません。";
        this.api_error = true;
      } else {
        //正常終了
        this.register_snackbar = true;
        this.register_result_message = "登録が完了しました";
        //this.deleteLocalStrage();
      }
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 9999;
  position: fixed;
  background-color: rgba(16, 17, 17, 0.2);
}
strong {
  color: #ff0000;
  font-weight: 900;
  font-size: 105%;
}
.header-label {
  margin-top: 4px;
}
.datepick {
  border: 0.2px ridge #cdcdcd;
  display: inline-block;
  margin: 0px 5px 10px 0px;
  padding: 3px;
  width: 95px;
  border-radius: 4px;
}
.selectBox {
  margin-bottom: 5px;
}
.selectBoxMode {
  margin-bottom: 5px;
}
.selectBoxInventoryPlace {
  margin-bottom: 10px;
  width: 80%;
}
.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield;
}
.table-record {
  font-size: 14px;
  font-weight: bold;
}
</style>
